/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useLDCContext } from '../../contexts/LoanDefaultCodesContext';
import SelectDropdown from './Dropdown';
import LoanInformationStyles from '../../css/LoanInformation.module.css';
import dateInputRow from './DateInputRow';

const fhlmcCol = () => {
  const { loanPropCode, LDCInfo, LDCUIStatuses, LDCFunctions, invReportUseColToggled } = useLDCContext();
  const { isEditable } = LDCUIStatuses;
  const { handleLDCChange } = LDCFunctions;

  const { FHLMCInactiveDate, FHLMCReactivateDate } = LDCInfo.dates;

  const { FHLMCStatusOptions, PropertyCondCodeOptions } = LDCInfo.QIDOptions;

  const { fhlmcStatus, propertyConditionCode } = LDCInfo;

  return (
    invReportUseColToggled && (
      <table className={LoanInformationStyles.loanInfoTableSection}>
        <tbody>
          <tr>
            <th>Investor Reporting Use Only</th>
          </tr>

          <SelectDropdown
            name={'fhlmcStatus'}
            value={fhlmcStatus}
            options={FHLMCStatusOptions}
            label={'FHLMC Status Flag'}
            func={(e) => {
              handleLDCChange('edit', 'fhlmcStatus', e.target.value);
              handleLDCChange('cancel', 'dates.FHLMCInactiveDate');
              handleLDCChange('cancel', 'dates.FHLMCReactivateDate');
            }}
          ></SelectDropdown>

          {fhlmcStatus === 'I' &&
            dateInputRow('FHLMC Inactive Status Date', FHLMCInactiveDate, 'dates.FHLMCInactiveDate', !isEditable)}

          {fhlmcStatus === 'A' &&
            dateInputRow(
              'FHLMC Reactivated Status Date',
              FHLMCReactivateDate,
              'dates.FHLMCReactivateDate',
              !isEditable,
            )}

          <SelectDropdown
            name={'propertyConditionCode'}
            value={propertyConditionCode}
            options={PropertyCondCodeOptions}
            label={'Property Condition Code'}
            func={(e) => {
              handleLDCChange('edit', 'propertyConditionCode', e.target.value);
              handleLDCChange('edit', 'propCode', loanPropCode);
            }}
          ></SelectDropdown>
        </tbody>
      </table>
    )
  );
};

export default fhlmcCol;
